import { _showAppLogs } from "../LogContext";

export const shouldUseCache = (timestamp_cache, timestamp_db, cache_groupType) => {
  // If the document was updated *after* the cache, ignore the cache

  // Timestamps are just numbers counting milliseconds since epoch — smaller = older
  // timestamp_db newer than timestamp_cache

  if (timestamp_db > timestamp_cache) {
    if (_showAppLogs.eventInfo) {
      console.group('Should useCache', cache_groupType)
      console.log(`🚫 Ignore cache data for ${cache_groupType}.`, timestamp_cache, timestamp_db, timestamp_db > timestamp_cache);
      console.groupEnd()
    }
    return false; // ignore cache
  }
  // _showAppLogs.eventInfo && console.log(`✅ CD ${cache_groupType}!`);
  return true; // cache is still valid
};